import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Button, Card, Col, Row, Table, Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
// import { useParams } from "react-router-dom";
import { getUserId } from "../services/authorize";
import { toThaiDateLong } from "../utils/thaiDate";

const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api').replace(/\/api\/?$/, '').replace(/\/$/, '');
const StudentAvatar = ({ photo, name }) => {
  const [hovered, setHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const initial = name ? name.trim().charAt(0) : '?';
  const circleStyle = { width: 28, height: 28, borderRadius: '50%', flexShrink: 0 };
  const src = photo ? `${UPLOAD_BASE}${photo.startsWith('/') ? photo : `/${photo}`}` : null;
  return (
    <>
      <span
        style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}
        onMouseEnter={() => src && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => src && setShowModal(true)}
      >
        {src
          ? <img src={src} alt="" style={{ ...circleStyle, objectFit: 'cover', cursor: 'pointer' }} />
          : <span style={{ ...circleStyle, backgroundColor: '#adb5bd', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{initial}</span>
        }
        {src && hovered && (
          <div style={{ position: 'absolute', left: 34, top: '50%', transform: 'translateY(-50%)', zIndex: 1050, background: '#fff', borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.25)', padding: 4 }}>
            <img src={src} alt={name} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6, display: 'block' }} />
          </div>
        )}
      </span>
      {src && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
          <Modal.Body className="p-3 text-center">
            <img src={src} alt={name} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
            {name && <div className="mt-2 fw-semibold small">{name}</div>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default function StudentInAdvice() {

  const { setLoading } = useLoading();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary')
        btn.classList.add('btn-white')
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table')
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary')
          thead.classList.add('table-primary')
        }
        table.classList.add('table-dark')
      } else {
        table.classList.remove('table-dark')
        for (const thead of theads) {
          thead.classList.remove('table-primary')
          thead.classList.add('table-secondary')
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  // จัดการ State สำหรับปีการศึกษาและข้อมูลที่โหลดได้
  const [yearList, setYearList] = useState([])
  const [yearId, setYearId] = useState(() => {
    return localStorage.getItem('yearId') || null
  })

  const [selectedYear, setSelectedYear] = useState("")
  const [data, setData] = useState([]);

  // ดึงรายการปีการศึกษา
  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API}/getStudyYear`, {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      })
      .then((res) => {
        const list = res.data;
        setYearList(list || []);
       // ถ้า yearId ยังไม่มีใน localStorage ให้ใช้ปีล่าสุด
      let initialYearId = localStorage.getItem('yearId');
        if (!initialYearId && list.length > 0) {
          initialYearId = list[0].year_id;
          localStorage.setItem('yearId', initialYearId);
        }
        setYearId(initialYearId);
        const selected = list.find(y => String(y.year_id) === String(initialYearId));
        setSelectedYear(selected ? `ปีการศึกษา ${selected.year_year}` : "");
      })
      .catch(err => {
        console.log("Error loading years:", err);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [setLoading])

  const [roomId, setRoomId] = useState(0)
  const [roomInfo, setRoomInfo] = useState(null) // ข้อมูลห้องเรียน (ชั้น/ห้อง/ปีการศึกษา) สำหรับหัวกระดาษพิมพ์
  useEffect(() => {
    if (!yearId) return;
    setLoading(true);
    axiosInstance.get(`${process.env.REACT_APP_API}/getRoomIdByAdvisorId/${getUserId()}/${yearId}`,
    {
      headers: {
            authorization: `Bearer ${getToken()}`
        }
    })
        .then(response => {
            setRoomId(response.data)
        })
        .catch(err => {
            // ไม่ได้เป็นครูประจำชั้นในปีที่เลือก — ต้องล้างห้องกับรายชื่อของปีก่อนทิ้ง
            // ไม่งั้นหน้าจอค้างรายชื่อปีเดิมไว้ทั้งที่ dropdown บอกอีกปีหนึ่ง
            setRoomId(0)
            setRoomInfo(null)
            setData([])
            // 404 = ปีนั้นเขาไม่ได้เป็นครูประจำชั้น ไม่ใช่ความผิดพลาด บอกที่หัวข้อพอ
            // ไม่ต้องเด้ง popup ทุกครั้งที่ไล่ดูปีเก่า
            if (err.response?.status !== 404) {
              Swal.fire({
                  title: err.response?.data?.title || 'เกิดข้อผิดพลาด',
                  text: err.response?.data?.message || err.message,
                  icon: "error"
              })
            }
        }).finally(() => {
          setLoading(false);
        })
    }, [setLoading, yearId]);

  useEffect(() => {
    if (!roomId) return;
    setLoading(true);
        
    axiosInstance.get(`${process.env.REACT_APP_API}/listStudentsInClass/${roomId}`,
    {
      headers: {
          authorization: `Bearer ${getToken()}`
      }
    })
      .then(response => {
        setData(response.data)
        // setIsLoading(false)
        // console.log(response.data)
      })
      .catch(err => {
        console.log(err.response.data.message)
        Swal.fire({
          title: err.response.data.title || err.response.statusText,
          text: err.response.data.message || err.message,
          icon: "error"
        })
      }).finally(() => {
        setLoading(false);
      })

  }, [setLoading, roomId]);

  // ดึงข้อมูลห้องเรียน (ชั้น/ห้อง/ปีการศึกษา) ไว้ใช้เป็นหัวกระดาษตอนพิมพ์รายชื่อ
  useEffect(() => {
    if (!roomId) return;
    axiosInstance.get(`${process.env.REACT_APP_API}/getRoomInfoForGrade/${roomId}`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
      .then(res => setRoomInfo(res.data))
      .catch(() => setRoomInfo(null));
  }, [roomId]);

  // หัวข้อห้องเรียน — "ชั้น ม.2/6 ปีการศึกษา 2569"
  // ปีการศึกษาที่เลือกค้างอยู่ใน localStorage ข้ามหน้าและข้ามวัน พอเปิดหน้านี้อีกที
  // รายชื่อที่เห็นจึงอาจเป็นของปีอื่นโดยไม่รู้ตัว หัวข้อต้องบอกให้ครบทั้งห้องและปี
  const roomLabel = roomInfo
    ? `ชั้น ม.${roomInfo.tb_class_c_id}/${roomInfo.r_no} ปีการศึกษา ${roomInfo.year_year}`
    : '';
  const noRoomThisYear = Boolean(yearId) && !roomId;

  const escHtml = (str) => String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  const handlePrintNameList = () => {
    const students = Array.isArray(data) ? data : []
    const c_class = roomInfo?.tb_class_c_id ?? ''
    const r_no = roomInfo?.r_no ?? ''
    const yearDisplay = roomInfo?.year_year ?? ''

    const blankCols = 10 // ช่องว่างสำหรับครูที่ปรึกษาบันทึก/ทำเครื่องหมายเอง
    // คอลัมน์รวมต้องเท่ากับ 100% เพื่อให้พอดีกับความกว้างกระดาษ (แนวตั้ง)
    const infoPct = 5 + 12 + 28 + 8 + 10 // เลขที่ + เลขประจำตัว + ชื่อ + ชั้นศาสนา + หอพัก
    const blankPct = (100 - infoPct) / blankCols

    const colgroup = `<colgroup>
        <col style="width:5%;" />
        <col style="width:12%;" />
        <col style="width:28%;" />
        <col style="width:8%;" />
        <col style="width:10%;" />
        ${Array.from({ length: blankCols }).map(() => `<col style="width:${blankPct}%;" />`).join('')}
      </colgroup>`

    const blankHeadCells = Array.from({ length: blankCols }).map(() => `<th></th>`).join('')
    const blankBodyCells = Array.from({ length: blankCols }).map(() => `<td></td>`).join('')

    const bodyRows = students.length > 0
      ? students.map((s, i) => {
          const isWithdrawn = s.st_status === '0'
          const isTransferred = !!s.transfer_room_id
          const rowClass = isWithdrawn ? ' class="hl-withdrawn"' : (isTransferred ? ' class="hl-transferred"' : '')
          let note = ''
          if (isWithdrawn) note = ' (จำหน่ายแล้ว)'
          else if (isTransferred) note = ` (ย้ายไป ม.${escHtml(s.transfer_class_id)}/${escHtml(s.transfer_room_no)})`
          return `<tr${rowClass}>
          <td class="c">${i + 1}</td>
          <td class="c">${escHtml(s.st_idnumber)}</td>
          <td class="name">${escHtml(s.st_name)}${note ? `<span class="note">${note}</span>` : ''}</td>
          <td class="c">${escHtml(s.ic_class ? `${s.ic_class}/${s.isl_room_no}` : '-')}</td>
          <td class="c">${escHtml(s.dorm_name || '-')}</td>
          ${blankBodyCells}
        </tr>`
        }).join('')
      : `<tr><td colspan="${5 + blankCols}" class="c">ไม่พบข้อมูล</td></tr>`

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>รายชื่อนักเรียน ม.${escHtml(c_class)}/${escHtml(r_no)}</title>
      <style>
        @page { size: A4 portrait; margin: 8mm; }
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; }
        body { font-family: 'Cordia New', 'TH Sarabun New', Tahoma, Arial, sans-serif; font-size: 16px; color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        h3 { text-align: center; margin: 0 0 6px 0; font-size: 16px; }
        table { border-collapse: collapse; width: 100%; table-layout: fixed; }
        th, td { border: 1px solid #000; padding: 2px 3px; overflow: hidden; word-wrap: break-word; }
        .head-table { margin-bottom: 6px; }
        .head-table td { vertical-align: middle; }
        .head-table .label { background: #f0f0f0; white-space: nowrap; font-weight: 600; }
        thead th { text-align: center; vertical-align: middle; background: #f0f0f0; }
        tbody .c { text-align: center; }
        tbody .name { padding-left: 6px; }
        tbody tr { height: 22px; }
        tbody .note { font-size: 11px; color: #555; }
        tbody .hl-withdrawn { background: #f8d7da; }
        tbody .hl-transferred { background: #fff3cd; }
      </style></head>
      <body onload="window.print()">
        <h3>โรงเรียนวัฒนธรรมอิสลาม</h3>
        <table class="head-table">
          <colgroup>
            <col style="width:14%;" /><col style="width:36%;" /><col style="width:16%;" /><col style="width:34%;" />
          </colgroup>
          <tr>
            <td class="label">ปีการศึกษา</td>
            <td>${escHtml(yearDisplay)}</td>
            <td class="label">ห้องเรียน</td>
            <td>ม.${escHtml(c_class)}/${escHtml(r_no)}</td>
          </tr>
        </table>
        <table>
          ${colgroup}
          <thead>
            <tr>
              <th>เลขที่</th>
              <th>เลขประจำตัว<br/>นักเรียน</th>
              <th>ชื่อ - สกุล นักเรียน</th>
              <th>ชั้นศาสนา</th>
              <th>หอพัก</th>
              ${blankHeadCells}
            </tr>
          </thead>
          <tbody>${bodyRows}</tbody>
        </table>
      </body></html>`

    const win = window.open('', '_blank', 'width=1200,height=900')
    win.document.write(html)
    win.document.close()
  }

  // Handle การเปลี่ยนปีการศึกษาจาก Dropdown
  const handleSelectYear = (id) => {
    const selected = yearList.find(y => y.year_id === id);
    if (selected) {
      setYearId(id);
      setSelectedYear(`ปีการศึกษา ${selected.year_year}`);
      localStorage.setItem('yearId', id); // <-- เก็บลง LocalStorage
    }
  }

  // สถานะนักเรียนเป็นของฝ่ายทะเบียน — ครูประจำชั้นดูได้อย่างเดียว
  // การจำหน่าย/สำเร็จการศึกษาทำที่ /registration/student-exit ซึ่งบังคับให้ระบุวันที่
  // สาเหตุ และปลายทางที่ไปเรียนต่อไปพร้อมกัน ต่างจากเมนูเดิมตรงนี้ที่พลิกสถานะได้เฉยๆ
  // โดยไม่เหลือหลักฐานว่าทำไม

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item">
                <Link to="#">ข้อมูลประจำชั้น</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                ข้อมูลนักเรียนทั้งหมดในห้องเรียน
              </li>
            </ol>
            <h4 className="main-title mb-0">ข้อมูลนักเรียนทั้งหมดในห้องเรียน</h4>
            {roomLabel && <div className="fs-sm text-secondary mt-1">{roomLabel}</div>}
            {noRoomThisYear && (
              <div className="fs-sm text-danger mt-1">ไม่ได้เป็นครูประจำชั้นในปีการศึกษานี้</div>
            )}
          </div>
      
          {/* Dropdown เลือกปีการศึกษา */}
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-basic">
                {selectedYear || "เลือกปีการศึกษา"}
              </Dropdown.Toggle>
          
              <Dropdown.Menu>
                {yearList.map((item) => (
                <Dropdown.Item
                  key={item.year_id}
                  onClick={() => handleSelectYear(item.year_id)}
                >
                  {`ปีการศึกษา ${item.year_year}`}
                </Dropdown.Item>
              ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                <Card.Title as="h6" className="mb-0">
                  {roomLabel || 'รายชื่อนักเรียน'}
                </Card.Title>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={handlePrintNameList}
                  disabled={!data || data.length === 0}
                >
                  <i className="ri-printer-line me-1"></i>พิมพ์รายชื่อ
                </Button>
              </Card.Header>
              <Card.Body className="p-3">
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center" style={{ width:"50px" }}>เลขที่</th>
                      <th scope="col" className="text-center" style={{ width: "100px" }}>เลขประจำตัว</th>
                      <th scope="col">ชื่อ-สกุล</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>ช้ันศาสนา</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>หอพัก</th>
                      <th scope="col" className="text-center" style={{ width: "150px" }}>สถานะ</th>
                      <th scope="col" className="text-center" style={{ width: "150px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                  {data && data.length > 0 ? (
                  data.map((data, index) => (
                      <tr key={data.st_id} className={data.st_status === '0' ? 'table-danger' : data.transfer_room_id ? 'table-warning' : ''}>
                        <th scope="row" className="text-center">{++index}</th>
                        <td className="text-center">{data.st_idnumber}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <StudentAvatar photo={data.st_photo} name={data.st_name} />
                            <span>
                              {data.st_name}
                              {data.transfer_room_id && (
                                <small className="text-muted ms-2">(ย้ายไป ม.{data.transfer_class_id}/{data.transfer_room_no})</small>
                              )}
                            </span>
                          </div>
                        </td>
                        <td className="text-center">{data.ic_class ? `${data.ic_class}/${data.isl_room_no}` : '-'}</td>
                        <td className="text-center">{data.dorm_name || '-'}</td>
                        <td className={data.st_status === '0' 
                            ? 'text-center text-danger' 
                            : data.st_status === '1'
                            ? 'text-center text-primary'
                            : 'text-center text-success'
                        }>
                          {data.status_text}
                          {data.st_status === '0' && data.ex_date && (
                            <div className="small">{toThaiDateLong(data.ex_date, { short: true })}</div>
                          )}
                        </td>
                        <td className="text-center">
                            <Link to={`/advisor/student-info/${data.st_id}`}><i className="ri-contacts-book-2-line"> แสดงข้อมูลนักเรียน</i></Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  )
}